// removed by extract-text-webpack-plugin
module.exports = {"grid":"G131f19"};